/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Members_Add_Apple_Sso_Email_HelpInputs */



/**
* | output |
* | --- |
* | "Only needed if the user hid their email address from Apple. They can read their privaterelay.appleid.com address off the \"No organizations found\" screen afte..." |
*
* @param {Members_Add_Apple_Sso_Email_HelpInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const members_add_apple_sso_email_help = /** @type {((inputs?: Members_Add_Apple_Sso_Email_HelpInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Members_Add_Apple_Sso_Email_HelpInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Nur nötig, wenn der Benutzer seine E-Mail-Adresse gegenüber Apple verborgen hat. Seine privaterelay.appleid.com-Adresse kann er nach einem Anmeldeversuch auf dem Bildschirm \"Keine Organisationen gefunden\" ablesen. Leer lassen, um die Adresse oben zu verwenden.")
	return /** @type {LocalizedString} */ ("Only needed if the user hid their email address from Apple. They can read their privaterelay.appleid.com address off the \"No organizations found\" screen after one sign-in attempt. Leave blank to use the address above.")
});